


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import jQuery from 'jquery';

import { Fields } from '@/common/ClaimsForm';

@Component({
	name: 'InformationAboutThePatientOrClaimantInvolvedFields',
	components: {
		SelectField,
		TextField,
		RadioField,
	},
})
export default class InformationAboutThePatientOrClaimantInvolved extends Vue {
	@Prop() private values: Fields;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	private statesList: typeof statesList = statesList;

	@State('policies', { namespace: 'Policy' }) private policies: any;

	private mounted() {
		jQuery('[data-toggle="popover"]').popover();
	}
	private enablePopOver() {
		jQuery('[data-toggle="popover"]').popover('enable');
	}
}
